<div class="matrix">
    <t-tile [tile]="tile"
            *ngFor="let tile of matrix$ | async">
    </t-tile>
</div>
